/**************************************************
 * Nombre:       Widget
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/

import {useEffect, useRef, useState} from "react";
import {obtenerHash} from "../Funciones/obtenerHash";
import {LLAVEPUBLICA, MONEDA, URLRECIBO} from "../Constantes";
import {Button} from "@mui/material";
import ic_wompi from '../Recursos/ic_wompi.svg'
import {irArriba} from "../../Utilidades/irArriba";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const BotonWompiAdentro = ({numPago, valor, funcion}) => {
    const {sCell} = useResponsive()
    const contenedorRef = useRef(null); // guardar el div real del DOM donde se pone el script de wompi
    const scriptRef = useRef(null); // guarda el script de wompi que se crea dinamicamente
    const [error, setError] = useState("");
    const [cargando, setCargando] = useState(false);

    const click = async () => {

        setCargando(true);
        setTimeout(() =>{
            setCargando(false)
        },5000)
        let dox = await funcion()

        if (dox) {
            irArriba()
            let btn = document.getElementsByClassName('waybox-button')
            if (btn && btn[0]) {
                btn[0].click()
            }
        }



    }

    useEffect(() => {

        const contenedor = contenedorRef.current;
        if (!contenedor) return undefined;

        let fecha = new Date()
        let dosHora = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours() + 2, 0, 0)
        let fechaEx = dosHora.toISOString()
        let valor_ = valor * 100


// Ejemplo de uso:


        obtenerHash({idVenta: numPago, valor: valor_, fechaExpiracion: fechaEx, moneda: MONEDA}).then((dox) => {


            contenedor.innerHTML = "";
            setError("");

            // PASO 1: CREAR EL ELEMENTO SCRIPT VACIO
            const script = document.createElement("script");
            // PASO 2: PONER EL SRC AL SCRIPT
            script.src = "https://checkout.wompi.co/widget.js";
            script.async = true;

            // DATOS NECESARIOS DE LA TRANSACCION
            script.setAttribute("data-render", "button");
            script.setAttribute("data-public-key", LLAVEPUBLICA);
            script.setAttribute("data-currency", MONEDA);
            script.setAttribute("data-amount-in-cents", valor_.toString());
            script.setAttribute("data-reference", numPago);
            script.setAttribute("data-signature:integrity", dox);
            script.setAttribute("data-expiration-time", fechaEx);
            script.setAttribute("data-redirect-url", URLRECIBO);

            // OPCIONALES Y QUE NO TENEMOS
            contenedor.appendChild(script);
            //contenedor.setMaxListeners(4)
            scriptRef.current = script;

        })


    }, [contenedorRef, numPago, valor])
    return (
        <div className="mt-3 w-500 wompi-boton" style={{width: '100%', backgroundColor: 'white'}}>
            <div id={'bt'} ref={contenedorRef} style={{display: 'none'}}></div>
            <Button
                loading={cargando}
                onClick={() => click()}
                endIcon={<img src={ic_wompi} width={150} height={'auto'}/>} fullWidth
                sx={{pt: 0.1, pb: 0, fontSize: sCell ? 14 : 16}}>Pagar Ahora

            </Button>

        </div>
    )

}
export default BotonWompiAdentro